import React from 'react';
import PropTypes from 'prop-types';
import css from './QuantityInput.module.scss';
import MinusCircleContainedIcon from '../../Icons/MinusCircleContainedIcon';
import AddSquare04Icon from '../../Icons/AddSquare04Icon';
import {colors} from "../../../utils/colors.js";

const QuantityInput = ({
  label,
  name,
  value,
  onChange,
  min = 0,
  max,
  step = 1,
  disabled = false,
  className = '',
}) => {
  const handleChange = (newValue) => {
    if (disabled) {
      return;
    }

    if (newValue === '' || isNaN(newValue)) {
      onChange({ target: { name, value: '' } });
      return;
    }

    let numericValue = parseInt(newValue, 10);
    if (isNaN(numericValue)) {
      return;
    }

    if (min !== undefined && numericValue < min) {
      numericValue = min;
    }
    if (max !== undefined && numericValue > max) {
      numericValue = max;
    }

    onChange({ target: { name, value: numericValue } });
  };

  const handleDecrease = () => {
    const current = parseInt(value || 0, 10);
    const next = current - step;
    if (min !== undefined && next < min) {
      if (min === 0) {
        handleChange('');
        return;
      }
      handleChange(min);
      return;
    }
    handleChange(next);
  };

  const handleIncrease = () => {
    const current = parseInt(value || 0, 10);
    const next = current + step;
    handleChange(next);
  };

  return (
    <div className={`${css.quantityInputContainer} ${className}`}>
      {label &&
        <label className={css.label}>
          {label}
        </label>
      }
      <div className={css.controls}>
        <button
          type="button"
          className={css.button}
          onClick={handleDecrease}
          disabled={disabled}
        >
          <MinusCircleContainedIcon color={colors.bgDark} />
        </button>
        <input
          type="number"
          name={name}
          className={css.input}
          value={value || ''}
          onChange={(e) => handleChange(e.target.value)}
          disabled={disabled}
        />
        <button
          type="button"
          className={css.button}
          onClick={handleIncrease}
          disabled={disabled}
        >
          <AddSquare04Icon color={colors.bgDark} />
        </button>
      </div>
    </div>
  );
};

QuantityInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default QuantityInput;

